import { gql } from '@apollo/client';

import { groupFragment } from '../fragments';

export default gql`
  query GroupsByCourse($courseId: String!) {
    groups(courseId: $courseId)
      @rest(type: "Group", path: "courses/{args.courseId}/groups") {
      ...Group
    }
  }
  ${groupFragment}
`;
